import React, { memo } from 'react';
import { Check, X, Lightbulb, Clock } from 'lucide-react';
export function TargetAudience() {
  return <section className="py-16 bg-white px-4" data-id="element-156">
      <div className="max-w-5xl mx-auto space-y-16" data-id="element-157">
        {/* Who is this for */}
        <div className="grid md:grid-cols-2 gap-12" data-id="element-158">
          <div className="bg-green-50 p-8 rounded-2xl border border-green-100" data-id="element-159">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-160">
              🚀 ¿Para quién es este producto?
            </h3>
            <ul className="space-y-4" data-id="element-161">
              {['Estudiantes de Medicina', 'Estudiantes de Enfermería', 'Estudiantes de carreras de la salud', 'Personas que quieren aprobar sin memorizar sin sentido'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-162">
                  <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-163" />
                  <span className="text-gray-800 font-medium" data-id="element-164">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-red-50 p-8 rounded-2xl border border-red-100 flex flex-col justify-center" data-id="element-165">
            <div className="flex items-start gap-4" data-id="element-166">
              <X className="w-8 h-8 text-red-600 flex-shrink-0" data-id="element-167" />
              <p className="text-xl font-bold text-gray-800" data-id="element-168">
                No es para quienes buscan apuntes extensos y teóricos sin
                organización.
              </p>
            </div>
          </div>
        </div>

        {/* Benefits */}
        <div className="bg-blue-900 text-white rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-169">
          <div className="text-center mb-10" data-id="element-170">
            <h3 className="text-2xl md:text-3xl font-bold flex items-center justify-center gap-3" data-id="element-171">
              <Lightbulb className="w-8 h-8 text-yellow-400" data-id="element-172" />
              ¿Qué cambia cuando estudias con este sistema?
            </h3>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-173">
            {['Menos tiempo de estudio', 'Mayor comprensión real', 'Mejor retención de la información', 'Más seguridad en los exámenes', 'Menos estrés y ansiedad'].map((benefit, i) => <div key={i} className="bg-white/10 backdrop-blur-sm p-4 rounded-lg text-center font-medium border border-white/10" data-id="element-174">
                {benefit}
              </div>)}
          </div>

          <div className="text-center" data-id="element-175">
            <p className="text-xl md:text-2xl font-bold text-yellow-300" data-id="element-176">
              👉 Pasas de “estudio mucho y no recuerdo”{' '}
              <br className="hidden md:block" data-id="element-177" />
              👉 a “entiendo, recuerdo y rindo mejor”.
            </p>
          </div>
        </div>

        {/* Immediate Access */}
        <div className="text-center max-w-3xl mx-auto" data-id="element-178">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center justify-center gap-2" data-id="element-179">
            <Clock className="w-7 h-7 text-blue-600" data-id="element-180" />⏳ Acceso inmediato
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm md:text-base font-medium text-gray-700" data-id="element-181">
            <div className="bg-gray-50 p-4 rounded-xl" data-id="element-182">
              Descarga digital instantánea
            </div>
            <div className="bg-gray-50 p-4 rounded-xl" data-id="element-183">
              Empieza a estudiar hoy mismo
            </div>
            <div className="bg-gray-50 p-4 rounded-xl" data-id="element-184">
              Úsalo en computadora, tablet o celular
            </div>
            <div className="bg-gray-50 p-4 rounded-xl" data-id="element-185">
              Material reutilizable toda la carrera
            </div>
          </div>
        </div>
      </div>
    </section>;
}